<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="仓库名称" prop="warehouseName">
              <el-input v-model="formData.warehouseName" placeholder="请输入仓库名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="warehouseType" label="仓库性质">
              <el-select v-model="formData.warehouseType" placeholder="请选择仓库性质" clearable>
                <el-option v-for="(item, index) of Array.from(warehouseTypeMap)" :key="index" :label="item[1]"
                  :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="managerType" label="仓库类型">
              <el-select v-model="formData.managerType" placeholder="请选择仓库类型" clearable>
                <el-option v-for="(item, index) of Array.from(managerTypeMap)" :key="index" :label="item[1]"
                  :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属公司" prop="company">
              <el-input v-model="formData.company" placeholder="请输入所属公司" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="warehouseCode">
              <el-input v-model="formData.warehouseCode" placeholder="请输入序号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库编码" prop="warehouseNo">
              <el-input v-model="formData.warehouseNo" placeholder="请输入仓库编码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省市区" prop="warRegion">
              <!-- <el-select v-model="formData.warRegion" placeholder="请选择省市区" clearable>
                <el-option v-for="(item, index) of areaList" :key="index" :label="item.areaName"
                  :value="item.areaId"></el-option>
              </el-select> -->
              <el-cascader v-model="areaValue" :props="{ value: 'label', label: 'label' }" :options="areaList"
                @change="handleAreaChange"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="warAddress">
              <el-input v-model="formData.warAddress" placeholder="请输入详细地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编" prop="warPostcode">
              <el-input v-model="formData.warPostcode" placeholder="请输入邮编" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="仓库管理员" prop="managerId" placeholder="请选择仓库管理员">
              <el-select v-model="formData.managerId" filterable>
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { managerType, warehouseType } from '@/utils/dict'
export default {
  name: 'WarehouseAdd',
  data() {
    return {
      userList: [],
      areaList: [],
      areaValue: [],
      managerTypeMap: managerType,
      warehouseTypeMap: warehouseType,
      formData: {
        warehouseName: '', // 仓库名称
        managerType: '', // 仓库类型1油罐2非油罐
        warehouseType: '', // 仓库性质1内库2外库
        company: '', // 所属公司
        warehouseCode: '', // 序号
        warehouseNo: '', // 仓库编码
        warRegion: '', // 省市区
        warAddress: '', // 详细地址
        warPostcode: '', // 邮编
        managerId: '' // 仓库管理员
      },
      rules: {
        warehouseName: [{ required: true, message: '请输入仓库名称' }],
        managerType: [{ required: true, message: '请选择仓库类型' }],
        warehouseType: [{ required: true, message: '请选择仓库性质' }]
      }
    }
  },
  computed: {
    warehouseId() {
      return this.$route.query.warehouseId
    }
  },
  created() {
    this.loadUserList()
    this.loadAreaList()
    if (this.warehouseId) {
      this.loadDetails()
    }
  },
  methods: {
    handleAreaChange(value) {
      this.formData.warRegion = value.join(' ')
    },
    loadAreaList() {
      this.$axios.get(this.$apis.common.selectCity).then(res => {
        this.areaList = res
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByWarehouseId, {
        params: { warehouseId: this.warehouseId }
      }).then(res => {
        if (res.warRegion) {
          this.areaValue = res.warRegion.split(' ')
        }
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.prodManage.insertLyWarehouse
        if (this.warehouseId) {
          url = this.$apis.prodManage.updateLyWarehouse
        }
        this.$axios.post(url, this.formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
